import * as React from 'react';
import moment from "moment";

export interface Props {
	value: any;
}

export default class QdDateDisplay extends React.Component<Props> {

	render() {
		let value = "";
		if (this.props.value) {
			
			let valueMoment = this.props.value;
			if (!valueMoment.format) {
				valueMoment = moment(valueMoment);
			}

			value = valueMoment.format("L");
		}
		
		return <span>{value}</span>
	}
}